import { useState } from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";
import Lightbox from "@/components/Lightbox";

const spanClass = {
  tall: "md:col-span-4 md:row-span-2 aspect-[3/4] md:aspect-auto",
  wide: "md:col-span-8 aspect-[4/3] md:aspect-[16/10]",
  normal: "md:col-span-4 aspect-[3/4]",
};

const EditorialGallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const images = GALLERY.map((g) => g.src);

  const openAt = (i) => {
    setIndex(i);
    setOpen(true);
  };

  return (
    <section
      id="editorial"
      data-testid="editorial-section"
      className="bg-white px-4 md:px-8 lg:px-12 py-24 md:py-32"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div>
          <span className="font-accent uppercase text-xs tracking-[0.3em] text-[#4a4a4a]">
            The Photography
          </span>
          <h2 className="font-serif-display text-5xl md:text-7xl tracking-tight leading-[0.9] mt-3">
            Editorial
            <br />
            <span className="italic font-light">in Motion</span>
          </h2>
        </div>
        <p className="max-w-sm font-light text-[#4a4a4a] leading-relaxed">
          No filler, no fluff — just the image. Selected frames from our shoots
          across Texas, shot with the eye of a New York studio.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-8 auto-rows-auto">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={g.title}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.7, 0, 0.2, 1] }}
            onClick={() => openAt(i)}
            data-testid={`gallery-item-${i}`}
            className={`group relative cursor-pointer overflow-hidden bg-[#f5f5f5] ${spanClass[g.span]}`}
          >
            <img
              src={g.src}
              alt={g.title}
              className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
            />
            <figcaption className="absolute inset-0 flex flex-col justify-end p-6 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <span className="font-accent uppercase text-[10px] tracking-[0.25em] text-white/70">
                {g.issue}
              </span>
              <span className="font-serif-display italic text-2xl text-white">
                {g.title}
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>

      <Lightbox
        images={images}
        index={index}
        open={open}
        onClose={() => setOpen(false)}
        onChange={setIndex}
      />
    </section>
  );
};

export default EditorialGallery;
